import { useState } from 'react';

export const useDependency = (fetchFn = () => {}, options = {}) => {
  const [items, setItems] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loadError, setLoadError] = useState('');

  const reset = () => {
    setIsLoaded(false);
  };

  const onLoad = (force) => {
    if (!force && (isLoading || isLoaded)) {
      return;
    }
    setIsLoading(true);
    fetchFn({
      onError: (message) => {
        setLoadError(message);
        setIsLoaded(true);
        setIsLoading(false);
      },
      onSuccess: (resp) => {
        setItems(options?.mapResponse ? options.mapResponse(resp) : resp);
        setIsLoaded(true);
        setIsLoading(false);
      }
    });
  };

  return { options: items, isLoading, isLoaded, loadError, reset, onLoad };
};
